import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgApexchartsModule } from 'ng-apexcharts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FilterPipe } from '@reenstudio/app/shared/pipe/filter.pipe';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { config } from '@reenstudio/app/core/config/oauth-config';

import { Amplify } from 'aws-amplify';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { awsmobile } from '@reenstudio/aws-exports';
import { LoggerModule, NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { environment } from '@reenstudio/environments/environment';
import { CoreModule } from './core/core.module';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { MonitoringModule } from './pages/monitoring/monitoring.module';
import localeIt from '@angular/common/locales/it';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import { AdministrationModule } from './pages/administration/administration.module';
import { IncentiveModule } from './pages/incentive/incentive.module';
import { ForecastModule } from './pages/forecast/forecast.module';

Amplify.configure(awsmobile);

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
registerLocaleData(localeIt);

@NgModule({
  declarations: [AppComponent, FilterPipe],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    TablerIconsModule.pick(TablerIcons),
    NgApexchartsModule,
    TablerIconsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LoggerModule.forRoot({
      level: environment.production
        ? NgxLoggerLevel.ERROR
        : NgxLoggerLevel.DEBUG,
    }),
    NgxPermissionsModule.forRoot(),
    AmplifyAuthenticatorModule,
    MaterialModule,
    CoreModule,
    MonitoringModule,
    ForecastModule,
    AdministrationModule,
    IncentiveModule,
  ],
  providers: [
    NgxPermissionsService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: config,
    },
    {
      provide: 'NGXLogger',
      useValue: NGXLogger,
    },
    {
      provide: LOCALE_ID,
      useValue: 'it',
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'it-IT',
    },
  ],
  exports: [TablerIconsModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
